var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import styled, { css } from "styled-components";
import { color } from "../templates/ui";
import ErrorLabel from "./ErrorLabel";
import _ from "lodash";
import InputLabel from "./InputLabel";
import { firstError } from "../../Services/Form";
import { getAppThemeName } from "../../Services/appTheme";
const StyledSelectWrapper = styled.div `
    position: relative;
    max-width: 100%;
    width: 350px;

    &:after {
        content: "";
        display: block;
        background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1Ny4yIDMyLjIiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDU3LjIgMzIuMiI+ICA8cGF0aCBkPSJNMCAzLjZDMCAyLjcuNCAxLjcgMS4xIDEgMi41LS40IDQuOC0uNCA2LjMgMWwyMi4zIDIyLjNMNTAuOSAxLjFjMS40LTEuNCAzLjctMS40IDUuMiAwIDEuNCAxLjQgMS40IDMuNyAwIDUuMmwtMjUgMjQuOWMtMS40IDEuNC0zLjcgMS40LTUuMiAwTDEuMSA2LjNDLjQgNS42IDAgNC42IDAgMy42eiIgZmlsbD0iIzAwMjg1NiIvPjwvc3ZnPg==);
        background-repeat: no-repeat;
        background-size: contain;
        width: 14px;
        height: 8px;
        position: absolute;
        top: 50%;
        right: 15px;
        transform: translateY(-50%);
        pointer-events: none;

        ${(props) => props.appTheme === "invoned" &&
    css `
                background-image: url("data:image/svg+xml,%3Csvg width='58' height='33' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M.525 4.125c0-.9.4-1.9 1.1-2.6 1.4-1.4 3.7-1.4 5.2 0l22.3 22.3 22.3-22.2c1.4-1.4 3.7-1.4 5.2 0 1.4 1.4 1.4 3.7 0 5.2l-25 24.9c-1.4 1.4-3.7 1.4-5.2 0l-24.7-24.9c-.8-.7-1.2-1.7-1.2-2.7Z' fill='%23600B6F' fill-rule='nonzero'/%3E%3C/svg%3E");
            `};
    }
`;
const StyledSelect = styled.select `
    transition: border-color 0.2s ease-in-out;
    position: relative;
    border: 1px solid ${(props) => props.theme.border};
    border-radius: 8px;
    width: 100%;
    background-color: ${color.body.base};
    height: 61px;
    padding-left: 20px;
    padding-right: 40px;
    color: ${(props) => props.theme.tertiary};
    font-size: 14px;
    font-weight: 400;
    appearance: none;
    min-width: 80px;
    cursor: pointer;

    &:focus {
        outline: none;
    }

    &:disabled {
        background-color: #efefef;
        opacity: 0.8;
    }

    option {
        color: #bbbbbb;
        font-weight: 400;
    }
`;
const InputSelect = (_a) => {
    var { label = "", error, options, tooltipContents, isMandatory = false, placeholder } = _a, props = __rest(_a, ["label", "error", "options", "tooltipContents", "isMandatory", "placeholder"]);
    error = typeof error === "object" ? firstError(error) : error;
    const [id] = useState(_.uniqueId("field-"));
    return (React.createElement(React.Fragment, null,
        React.createElement(InputLabel, { htmlFor: id, isMandatory: isMandatory || props.required, tooltipContents: tooltipContents }, label),
        React.createElement(StyledSelectWrapper, { appTheme: getAppThemeName() },
            React.createElement(StyledSelect, Object.assign({ id: id }, props),
                placeholder && React.createElement("option", { value: "" }, placeholder),
                options.map((option) => (React.createElement("option", { key: option.id, value: option.value }, option.name))))),
        !!error && React.createElement(ErrorLabel, null, _.capitalize(error))));
};
export default InputSelect;
